// +----------------------------------------------------------------------
// | ThisAdmin [ ThisAdmin赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2022 https://www.thisadmin.cn All rights reserved.
// +----------------------------------------------------------------------
// | Licensed ThisAdmin并不是自由软件，未经许可不能去掉ThisAdmin相关版权
// +----------------------------------------------------------------------
// | Author: ThisAdmin Team   Email: oszzw@qq.com
// +----------------------------------------------------------------------

import index from './modules/index';
import user from './modules/user';
import memberDisplay from './modules/memberDisplay';
import course from './modules/course';
import complaint from './modules/complaint';
import certificate from './modules/certificate';
import service from './modules/service';
import news from './modules/news';

//应用路由
const routes = [
  index,
  user,
  memberDisplay,
  course,
  complaint,
  certificate,
  service,
  news,
  {
    path: '/:catchAll(.*)',name: '404',
    component: () => import(/* webpackChunkName: "[404]" */ '@/views/404.vue'),
    meta: {title: '访问错误404'}
  }
]

// 重新组织后导出
export default [
  ...routes
];